import { Inject, Injectable } from '@angular/core';
import { LinkedinInsightsConfiguration } from '../linkedin-insights.module';

const eventMap = {
  'Sign in': '3971305',
  'Sign up': '3971297',
};

@Injectable({
  providedIn: 'root',
})
export class LinkedinInsightsService {
  private initialized = false;

  constructor(@Inject('linkedinConfig') private config: LinkedinInsightsConfiguration) {}

  initialize() {
    if (!this.config.enabled || this.initialized) {
      return;
    }

    const script = `
      _linkedin_partner_id = "${this.config.linkedinId}"; 
      window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || []; 
      window._linkedin_data_partner_ids.push(_linkedin_partner_id);
      (function(){var s = document.getElementsByTagName("script")[0]; var b = document.createElement("script"); b.type = "text/javascript";b.async = true; b.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js"; s.parentNode.insertBefore(b, s);})();
    `;

    const scriptElement = document.createElement('script');
    scriptElement.textContent = script;

    document.body.appendChild(scriptElement);

    this.initialized = true;
  }

  track(eventName) {
    const conversionId = eventMap[eventName];

    if (conversionId) {
      const imgElement = document.createElement('img');

      imgElement.height = 1;
      imgElement.width = 1;
      imgElement.style.display = 'none';
      imgElement.alt = '';
      imgElement.src = `https://px.ads.linkedin.com/collect/?pid=${this.config.linkedinId}&conversionId=${conversionId}&fmt=gif`;

      document.body.appendChild(imgElement);
    }
  }
}
